export default __webpack_public_path__ + "static/783-f70d01268bed5eef2f7a95fae3685237.gif";